export function getViewportHeight() {
    return window.visualViewport?.height ?? window.innerHeight;
}

export function createStableResizeHandler(onResize: () => void) {
    let width = window.innerWidth;

    return () => {
        const nextWidth = window.innerWidth;
        const widthChanged = nextWidth !== width;
        const isTouchViewport = navigator.maxTouchPoints > 0;

        if (isTouchViewport && !widthChanged) {
            return;
        }

        width = nextWidth;
        onResize();
    };
}

export function getScopedViewportHeight(element: HTMLElement) {
    const value = window
        .getComputedStyle(element)
        .getPropertyValue('--simulaix-vh');
    const height = Number.parseFloat(value);

    return Number.isFinite(height) ? height : getViewportHeight();
}
